import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { camelCase, clone } from "lodash-es";

import { DEPOSIT_LIMIT_ACTION_TYPE } from "./deposit-limit.action";
import { DepositLimit, DepositLimits, DepositLimitState, DepositLimitType } from "./deposit-limit.model";

const INITIAL_STATE: DepositLimitState = {};

export function depositLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): DepositLimitState {
	switch (action.type) {
		case DEPOSIT_LIMIT_ACTION_TYPE.getAllSuccess: {
			return updateState(state, {
				depositLimits: action.payload as DepositLimits,
			});
		}
		case DEPOSIT_LIMIT_ACTION_TYPE.updateSuccess:
		case DEPOSIT_LIMIT_ACTION_TYPE.removeSuccess: {
			const depositLimit = action.payload as DepositLimit;

			let depositLimitTypeProperty = "";
			const depositLimitsClone = clone(state.depositLimits);

			if (!depositLimitsClone) {
				return state;
			}

			if (depositLimit.depositLimitType === DepositLimitType.TemporaryAccountLifetimeLimit) {
				depositLimitTypeProperty = camelCase(DepositLimitType.TemporaryAccountLifetimeLimit);
				depositLimitsClone[depositLimitTypeProperty] = depositLimit;
			} else {
				// TODO: Revisit this implementation when API changes the way deposit limit response is sent irrespective of 'depositLimitType'
				depositLimitsClone[camelCase(DepositLimitType.ResponsibleGaming)] = depositLimit;
				depositLimitsClone[camelCase(DepositLimitType.PureDepositLimit)] = depositLimit;
			}

			return updateState(state, {
				depositLimits: depositLimitsClone,
			});
		}
		case DEPOSIT_LIMIT_ACTION_TYPE.getUnconfirmedSuccess: {
			return updateState(state, {
				depositLimitsUnconfirmed: action.payload as DepositLimits,
			});
		}
		case DEPOSIT_LIMIT_ACTION_TYPE.acceptUnconfirmedSuccess:
		case DEPOSIT_LIMIT_ACTION_TYPE.declineUnconfirmedSuccess:
		case DEPOSIT_LIMIT_ACTION_TYPE.clear: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
